import React from 'react';
import {atom} from 'jotai';
import {IMetrixOverviews} from "../models/IMetrixOverviews";

export const lastMetrixAtom = atom<string | null>(null);
export const overviewAtom = atom<IMetrixOverviews | null>(null);
